import { forwardRef, memo, useImperativeHandle, useRef } from 'react';
import { Flex } from '@eqi-investimentos/react';
import { CSSTransition } from 'react-transition-group';
import { Icon } from '@/components/elements/Icon';
import './KeyAction.css';

const KeyAction = forwardRef<KeyActionHandle, KeyActionProps>(
  ({ on, volume, onClick = () => null }, ref) => {
    const rewindRef = useRef<HTMLDivElement>(null);
    const skipRef = useRef<HTMLDivElement>(null);

    useImperativeHandle(ref, () => ({
      get rewind() {
        return rewindRef.current!;
      },
      get skip() {
        return skipRef.current!;
      },
    }));

    return (
      <Flex
        pos="absolute"
        top="0"
        bottom="0"
        left="0"
        right="0"
        onClick={onClick}
      >
        <CSSTransition
          in={on}
          classNames="vp-key-volume"
          timeout={300}
          mountOnEnter
          unmountOnExit
        >
          <div className="vp-key-action__volume">
            <div className="vp-key-action__volume__container">
              <div className="vp-key-action__volume__icon">
                {volume > 0 && (
                  <Icon iconName={'VolumeOnOutline'} color={'white'} />
                )}
                {volume === 0 && (
                  <Icon iconName={'VolumeOffOutline'} color={'white'} />
                )}
              </div>
              <div className="vp-key-action__volume__range">
                <div className="vp-key-action__volume__range--background" />
                <div
                  className="vp-key-action__volume__range--current"
                  style={{ width: `${volume * 100}%` }}
                />
              </div>
            </div>
          </div>
        </CSSTransition>
        <div className="vp-key-action__progress rewind" ref={rewindRef}>
          <div className="vp-key-action__progress__container">
            <Icon iconName={'ChevronDoubleLeft'} color={'white'} />
            <span>- 10 segundos</span>
          </div>
        </div>
        <div className="vp-key-action__progress skip" ref={skipRef}>
          <div className="vp-key-action__progress__container">
            <Icon iconName={'ChevronDoubleRight'} color={'white'} />
            <span>+ 10 segundos</span>
          </div>
        </div>
      </Flex>
    );
  }
);

KeyAction.displayName = 'KeyAction';

export default memo(KeyAction);

export type KeyActionHandle = {
  rewind: HTMLDivElement;
  skip: HTMLDivElement;
};

type KeyActionProps = {
  on: boolean;
  volume: number;
  onClick?: () => void;
};
